<template>
  <div class="right">
    <div class="field_left">
      <text-input id="streamProfilename"
                  :required="true"
                  v-model="entity.name"
                  :disabled="disabled"
                  ref="nameref"
      >
        <translate class="translate">Název</translate>

      </text-input>

      <text-input id="streamProfilecode"
                  :required="true"
                  :disabled="disabled"
                  v-model="entity.code"
                  ref="coderef"
      >
        <translate class="translate">Kód</translate>
      </text-input>
      <checkbox-input
          id="streamprofilevod"
          v-model="entity.vod"
          ref="vodref"
          :disabled="disabled"
      >
        <translate class="translate">Videotéka</translate>
      </checkbox-input>
    </div>
    <div class="field_right">
      <text-input id="streamProfilesyncgroup"
                  v-model="entity.sync_group"
                  ref="syncgroupref"
                  :disabled="disabled"
      >
        <translate class="translate">Synchronizační skupina</translate>
      </text-input>
      <text-input id="streamProfileweight"
                  :required="true"
                  v-model="entity.weight"
                  ref="weightref"
                  :disabled="!isEditable"
      >
        <translate class="translate">Váha</translate>
      </text-input>
      <checkbox-input
          id="streamprofilethumbnail"
          v-model="entity.thumbnail"
          ref="thumbnailref"
          :disabled="disabled"
      >
        <translate class="translate">Stream pro náhledy</translate>
      </checkbox-input>
    </div>
  </div>
</template>

<script>
import TextInput from "@/components/common/TextInput"

import formFilterData from "@/components/mixins/form-filter-data"
import requiredFields from "@/components/mixins/required-fields"

export default {
  name: "StreamProfileBasicForm",
  components: {TextInput},
  mixins: [formFilterData, requiredFields],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  computed: {
    disabled(){
      return !this.isEditable || !this.$_updateActionAllowed;
    }
  },
  methods: {
    validateStreamProfileFormRequiredFields() {
      let nameError = null
      let codeError = null

      if (!this.entity.name) {
        nameError = this.$gettext('Zadejte název')
      }

      if (!this.entity.code) {
        codeError = this.$gettext('Zadejte kód')
      } else if (this.entity.code.length < 2) {
        codeError = this.$gettext('Kód musí obsahovat min. 2 znaky')
      }

      if (nameError !== null) {
        this.setFieldInvalid('nameref', true, nameError)
      } else {
        this.setFieldInvalid('nameref')
      }

      if (codeError !== null) {
        this.setFieldInvalid('coderef', true, codeError)
      } else {
        this.setFieldInvalid('coderef')
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/streamProfiles/forms/StreamProfileBasicForm.vue